import { render, staticRenderFns } from "./dtm-pay.vue?vue&type=template&id=ad033ffe&"
import script from "./dtm-pay.vue?vue&type=script&lang=js&"
export * from "./dtm-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports